import { DEFAULT_MODAL_STYLE } from "shared/Modal"

// Shared by the modals in the edit-submission flow, so that moving
// from one modal to the next looks like staying in the same modal.
// The minimum height keeps the modals the same size, since their
// content is not the same height.
const EDIT_SUBMISSION_MODAL_STYLE = {
  content: {
    ...DEFAULT_MODAL_STYLE.content,
    minHeight: "416px",
    top: "47%",
  },
}

export default EDIT_SUBMISSION_MODAL_STYLE
